'use client';
import React, { FC, PropsWithChildren } from 'react';
import { Auth0Provider } from '@auth0/nextjs-auth0';
import { GraphqlProvider } from '@/api/providers/GraphqlProvider/GraphqlProvider';
import { ErrorBoundary } from '@/common/errors/ErrorBoundary';
import { AuthenticationProvider } from '@/common/providers/AuthenticationProvider/AuthenticationProvider';
import { AuthorizationProvider } from '@/common/providers/AuthorizationProvider/AuthorizationProvider';
import { LanguageSelector } from '@/common/views/LanguageSelector';

const OrganizationLayout: FC<PropsWithChildren> = ({ children }) => (
  <Auth0Provider>
    <AuthenticationProvider>
      <GraphqlProvider>
        <AuthorizationProvider>
          <ErrorBoundary>
            <LanguageSelector />
            {children}
          </ErrorBoundary>
        </AuthorizationProvider>
      </GraphqlProvider>
    </AuthenticationProvider>
  </Auth0Provider>
);

export default OrganizationLayout;
